import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { GetAllInvestigationTypesResult } from './get-all-investigation-types.result';

@Injectable({ providedIn: 'root' })
export class GetAllInvestigationTypesUseCase {
  private readonly _repository = inject(InvestigationTypeRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(): Observable<GetAllInvestigationTypesResult> {
    this._state.setLoading(true);
    this._state.clearError();

    return this._repository.getAllInvestigationTypes().pipe(
      tap((investigationTypes) => {
        this._state.setInvestigationTypes(investigationTypes);
        this._state.setLoading(false);
      }),
      map((investigationTypes) => ({ investigationTypes })),
      catchError((error) => {
        this._state.setError(
          error?.error?.message || error?.message || 'Failed to load investigation types',
        );
        throw error;
      }),
    );
  }
}
